export default {"src":"/_next/static/media/features-exclusive-playlist.edadda9f.gif","height":540,"width":800};